import React from 'react';
import { SwiperSlide } from 'swiper/react';
import styled, { css } from 'styled-components';

import { SliderWrapper } from '@/components/LandingWidgets';
import AboutCardPrimaryBenefit from '@/components/LandingWidgets/components/AboutCardPrimary/components/AboutCardPrimaryBenefit';
import { Component as AboutCardPrimaryBenefitComponent } from '@/components/LandingWidgets/components/AboutCardPrimary/components/AboutCardPrimaryBenefit/AboutCardPrimaryBenefit';
import { media } from '@/utils/mixin';

import { AboutCardPrimaryBenefitSliderProps } from './types';

function AboutCardPrimaryBenefitSlider({
  id,
  benefits,
}: AboutCardPrimaryBenefitSliderProps) {
  if (!benefits || benefits.length === 0) {
    return null;
  }

  return (
    <Component>
      <SliderWrapper id={id} options={{ spaceBetween: 20, withoutNavs: true }}>
        {benefits.map(({ image, text }, index) => (
          <SwiperSlide key={index}>
            <AboutCardPrimaryBenefit image={image} text={text} />
          </SwiperSlide>
        ))}
      </SliderWrapper>
    </Component>
  );
}

export default AboutCardPrimaryBenefitSlider;

const Component = styled.div`
  ${AboutCardPrimaryBenefitComponent} {
    ${media.tablet(css`
      max-width: 320px;
      margin: 0 auto;
    `)}
  }
`;
